import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import TextField from "@material-ui/core/TextField";

import Autocomplete from "src/components/Autocomplete";
import { getAllSales } from "src/store/sale/selector";
import type { Sale } from "src/interfaces/sale.interface";

function SaleAutocompleteField({
  value,
  onChange,
  disabled,
}: {
  value?: string;
  onChange: (sale: Sale | null) => void;
  disabled?: boolean;
}) {
  const sales = useSelector(getAllSales);
  const sale = useMemo(() => {
    if (!value) return null;
    return (
      sales.find((sale) => sale.transaction_id === value) ||
      sales.find((sale) => sale.id === value)
    );
  }, [value, sales]);

  return (
    <Autocomplete
      fullWidth
      options={sales}
      value={sale}
      onChange={(ev, option) => onChange(option)}
      autoHighlight
      renderInput={(params) => (
        <TextField
          {...params}
          margin="dense"
          label="Linked Sale"
          fullWidth
          variant="outlined"
        />
      )}
      getOptionSelected={(option, value) => option.id === value.id}
      getOptionLabel={(sale) => {
        return [sale?.sku, sale?.item_title].filter(Boolean).join(" - ");
      }}
      disabled={disabled}
    />
  );
}

export default SaleAutocompleteField;
